import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalOpenInvite: ExperimentalQueries['experimentalOpenInvite'] = async (
	_,
	{ cloudId },
	{ network },
) => {
	if (!cloudId) {
		return Promise.reject(new Error('cloudId is missing.'));
	}

	const queryString = new URLSearchParams({
		resource: `ari:cloud:confluence::site/${cloudId}`,
	}).toString();

	return network
		.cfetch(`/gateway/api/invitations/v1/settings/open-invite?${queryString}`, {
			method: 'GET',
		})
		.then((res) => res.json());
};
